var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51953 14.7571C3.51953 14.7571 4.77789 14.3726 5.84978 15.8989C6.89868 17.3925 8.84013 19.812 10.5715 17.5242C10.5861 17.505 10.6046 17.4889 10.6257 17.477C10.6468 17.4651 10.6701 17.4577 10.6942 17.4552C10.7183 17.4527 10.7427 17.4551 10.7658 17.4624C10.7889 17.4696 10.8103 17.4816 10.8286 17.4974C11.3662 17.9604 13.2576 19.3545 13.8182 16.6007C13.8265 16.5598 13.8434 16.5211 13.8676 16.4872C13.8919 16.4533 13.9231 16.4248 13.9591 16.4037C13.995 16.3826 14.0351 16.3693 14.0765 16.3647C14.118 16.3601 14.16 16.3643 14.1997 16.377C14.9843 16.6277 16.8999 17.0185 16.4947 14.6796C16.4332 14.3248 16.2648 13.9974 16.0119 13.7411L12.8871 10.5742",
    stroke: "#E5E7EB",
    strokeWidth: 1.16674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4146 7.78516H3.51962V16.3061C3.51962 16.5265 3.43205 16.7379 3.27619 16.8937C3.12033 17.0496 2.90893 17.1372 2.68851 17.1372H1.4146C1.19418 17.1372 0.982784 17.0496 0.826921 16.8937C0.671059 16.7379 0.583496 16.5265 0.583496 16.3061V8.61632C0.583489 8.50717 0.604981 8.39909 0.646744 8.29825C0.688508 8.19741 0.749726 8.10578 0.826902 8.0286C0.904078 7.95142 0.9957 7.8902 1.09654 7.84843C1.19738 7.80666 1.30545 7.78516 1.4146 7.78516Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.16674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6894 17.1367H20.4157C20.3066 17.1367 20.1985 17.1152 20.0977 17.0735C19.9968 17.0317 19.9052 16.9705 19.828 16.8933C19.7509 16.8161 19.6896 16.7245 19.6479 16.6237C19.6061 16.5228 19.5846 16.4148 19.5846 16.3056V7.78471H21.6894C21.7985 7.78471 21.9066 7.80621 22.0075 7.84798C22.1083 7.88974 22.1999 7.95096 22.2771 8.02814C22.3543 8.10531 22.4155 8.19693 22.4572 8.29777C22.499 8.3986 22.5205 8.50667 22.5205 8.61582V16.3056C22.5205 16.4148 22.499 16.5228 22.4572 16.6237C22.4155 16.7245 22.3543 16.8161 22.2771 16.8933C22.1999 16.9705 22.1083 17.0317 22.0075 17.0735C21.9066 17.1152 21.7985 17.1367 21.6894 17.1367Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.16674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7516 14.7754H17.0039V14.822H18.7516V14.7754Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.16674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7805 7.66086C17.7805 7.66086 14.8186 4.11892 11.5109 6.286C9.92139 7.66169 8.94078 8.39262 8.43131 8.89476C7.90405 9.41441 7.58803 10.1136 7.55853 10.8533C7.52653 11.6554 8.04012 12.3136 9.34675 12.4356C9.74883 12.4731 10.1252 12.2207 10.4319 11.9581L13.6871 9.26095",
    stroke: "#E5E7EB",
    strokeWidth: 1.16674,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1898 5.58398C9.1898 5.58398 6.44013 5.92095 5.21289 7.78512",
    stroke: "#E5E7EB",
    strokeWidth: 1.16674,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.104,
    height: 14.0467,
    fill: "white",
    transform: "translate(0 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.545674a6295b68d03bcc928dd0a26a04.svg";
export { ForwardRef as ReactComponent };